import React, { useState, useEffect  } from "react";
import { useTranslation } from "react-i18next";
import { TabView, TabPanel } from 'primereact/tabview';
import { toast } from "react-toastify";
import PaymentOrderHistory from "./PaymentOrderHistory";
import SplitPane, { Pane } from "react-split-pane";
import { useAppContext } from "../../../AppContext";
import mainAxios from "../../../services/mainAxios";
import Loader from "../../Layout/Loader";
import Page404 from "../../Page404";
import TooltipOverlay from "../../global/TooltipOverlay";
import PaymentOrderInfo from "./PaymentOrderInfo";
import PaymentOrderComments from "./PaymentOrderComments";
import PaymentOrderDocPreview from "./PaymentOrderDocPreview";
import PaymentBankAccounts from "./PaymentBankAccounts";
import PaymentPurchaseInvoice from "./PaymentPurchaseInvoice";


const EditPaymentOrder = (props) => {
  const { t } = useTranslation("translations");
  const { user: [user],selectedCompany: [selectedCompany], company: [fullCompany]} = useAppContext();
  const [loading, setLoading] = useState(false);
  const [paymentOrderAttachments,  setPaymentOrderAttachments] = useState([]);
  const paymentOrderId = props.match.params.id;
  const [invoice, setInvoice] = React.useState(null);
  const [pageLoading, setPageLoading] = React.useState(true);
  const [isDesktop, setDesktop] = useState(window.innerWidth > 768);
  const [reoladPage,setReloadPage]=useState(false)

console.log({paymentOrderAttachments})
  
  const updateMedia = () => {
    setDesktop(window.innerWidth > 768);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  const getPaymetById=()=>{
    mainAxios
      .post("/payment/get-order-by-id", {
        value: paymentOrderId,
      })
      .then((res) => {
        const content = res?.data?.content?.[0]
        if(content){
          setPageLoading(false);
          setInvoice(content);
        }
      });
  }

  useEffect(() => {
    getPaymetById()
  }, [paymentOrderId, selectedCompany,reoladPage]);


  const dummyPurchaseHistorics = [
    {
      id: 1,
      workflowAction: { name: "Action 1" },
      workflowStatus: { name: "Status 1" },
      comment: "This is a comment for purchase historic 1.",
      recordDate: new Date(),
      recordUser: "User 1",
      purchaseHistoricAttachments: [
        {
          id: 1,
          name: "attachment1.pdf",
          type: "pdf"
        },
        {
          id: 2,
          name: "attachment2.jpg",
          type: "jpg"
        }
      ]
    },
    {
      id: 2,
      workflowAction: { name: "Action 2" },
      workflowStatus: { name: "Status 2" },
      comment: "This is a comment for purchase historic 2.",
      recordDate: new Date(),
      recordUser: "User 2",
      purchaseHistoricAttachments: [
        {
          id: 3,
          name: "attachment3.xlsx",
          type: "xlsx"
        },
        {
          id: 4,
          name: "attachment4.docx",
          type: "docx"
        }
      ]
    }
  ];
console.log({invoice})
  const savePaymentOrder = (action) => {
    setLoading(true);
    console.log({action});
    
    const parsedInvoice={
      ...invoice,
      paymentAttachments: paymentOrderAttachments,
      buyerBankAccount:invoice?.buyerBankAccount?.id?{id:invoice?.buyerBankAccount?.id}:null,
      sellerBankAccount:invoice?.sellerBankAccount?.id?{id:invoice?.sellerBankAccount?.id}:null,
    }
    mainAxios
      .post("/payment/save-order", {
        operation: action?.statusTo,
        content:parsedInvoice,
        nuis: user.companiesRights.find(
          (company) => company.id === parseInt(selectedCompany)
        )?.nuis,
      })
      .then((res) => {
        setLoading(false);
          setReloadPage((state)=>!state);
          setPaymentOrderAttachments([]);
          toast.success(t("common.actionSuccessfully"), {
            containerId: "all_toast",
          });
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleChange = (e, selectKey, selectValue, length) => {
    const key = e ? e?.target?.name : selectKey;
    let value = e ? e?.target?.value : selectValue;
    let keys = key.split(".");
    value = length != undefined ? value.slice(0, length) : value;
    switch (keys.length) {
      case 1:
        setInvoice((invoiceState) => ({
          ...invoiceState,
          [keys[0]]: value,
        }));
        break;
      case 2:
        setInvoice((invoiceState) => ({
          ...invoiceState,
          [keys[0]]: {
            ...(invoiceState[keys[0]] ? {...invoiceState[keys[0]]}:{}),
            [keys[1]]: value,
          },
        }));
        break;
      case 3:
        setInvoice((invoiceState) => ({
          ...invoiceState,
          [keys[0]]: {
            ...(invoiceState[keys[0]] ? {...invoiceState[keys[0]]}:{}),
            [keys[1]]: {
              ...(invoiceState[keys[0]] && invoiceState[keys[0]][keys[1]] ?{...invoiceState[keys[0]][keys[1]]}:{}),
              [keys[2]]: value,
            },
          },
        }));
        break;
      default:
        return;
    }
  };

  const buildActionButton = (action) => {
    let name = action?.action ??  ((action.statusTo ?? "").charAt(0).toUpperCase() + (action.statusTo ?? "").slice(1)) ?? "";
    switch (action.statusTo) {
      case "accepted-customer-profile-2":
        return{
          className:action.color,
          name
        }
      default:
        return {
          className: action.color,
          name,
        };
    }
  };

   const staticActions=()=>{
    return (
      <>
      {invoice?.conditions?.allowSave && <button
          className={`btn btn-primary mr-3`}
          disabled={loading}
          style={{ minWidth: "100px" }}
          onClick={() => {
            savePaymentOrder({action:"save",statusTo:"save"});
          }}
        >
          {loading ? <Loader size="xs" color="white" /> : t("common.save")}
        </button>}
        {invoice?.conditions?.allowReturn && <button
          className={`btn btn-warning mr-3`}
          disabled={loading}
          style={{ minWidth: "100px" }}
          onClick={() => {
            savePaymentOrder({action:"return",statusTo:invoice?.workflowStatus?.name});
          }}
        >
          {loading ? <Loader size="xs" color="white" /> : t("status.return")}
        </button>}
    </>
    )
  }
  

  const actions = () => {
    let conditions = invoice?.conditions;
    if ( conditions) {
      let orderActions = ["reject","Approve CIS","return","submit for approval"];
      let oldActions=[...conditions.actionStatusToList];
      let newActions=[];
      orderActions.forEach((actionInTurn)=>{
        oldActions.forEach((action,index)=>{
          if(actionInTurn==action.action){
            newActions.push(action);
            oldActions.splice(index,1);
            return;
          }
        })
      })
      newActions=[...newActions,...oldActions];
      


      return newActions.map((action,index) => {
        let actionButton = buildActionButton(action);
        return (
          <button
            key={index}
            className={`btn mr-3 ${actionButton?.className ? `badge-${actionButton.className}`:"badge-light"}`}
            disabled={loading}
            style={{ minWidth: "100px",color:"white" }}

            onClick={() => {
              savePaymentOrder(action);
            }}
          >
            {loading ? <Loader size="xs" color="white" /> : actionButton.name}
          </button>
        );
      });
    }
    return <></>;
  };

  let actionButtons = actions();
  let staticButtons = staticActions();

  const buildStatus=()=>{
    let {name,id,active}=invoice?.status ?? {};
    name=(name?.split("-") ?? []).map(splited=>(splited[0].toUpperCase()) +(splited?.slice(1) ?? "")).join(" ")
    console.log({name})
    switch(id){
      case 1:return {
        badge:"primary",
        name:"Accepted Customer Profile"
      }//draft
      case 3:return {
        badge:"info",
        name: t("purchases.finance")
      };//finance
      case 4:return  {
        badge:"accepted-customer-profile",
        name: t("queue.accepted")
      }//accepted
      case 5:return {
        badge:"danger",
        name: t("purchases.refused")
      }//refused
      default:return {badge:"info",name};
    }
  }

  const refreshData=()=>setReloadPage((state)=>!state);


  let status=buildStatus()
  return !pageLoading ? (
    invoice ? (
      <div className="my-4">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="d-flex align-items-center justify-content-center">
            <h3 className="mb-0 mr-4">Edit Payment Order</h3>
            {invoice?.workflowStatus?.name &&(
            <TooltipOverlay title="Workflow Status" show={50} hide={50}
            >
            <div style={{fontSize:18,cursor:"default"}} className={`text-center badge badge-${status?.badge ?? ""}`}>
                {status?.name}
              </div>
              </TooltipOverlay>
            )}
          </div>
          <div className="d-flex align-items-center ml-4">
          <div className="extracted">
            </div>
            {staticButtons}
            {actionButtons}
          </div>
        </div>
          {isDesktop?
          <div style={{height:"100vh"}} className="mt-4">
          <SplitPane
            defaultSize="55%"
            minSize={0}
            style={{ height: "100%" }}
            split="vertical"
          >
            <div className="mx-4 mb-4" style={{minHeight: 400}}>
              <div className="purchase-tab purchase-nav">
                <TabView className="mb-4 shadow ">
                <TabPanel
                  header="Payment Order Info" headerStyle={{fontSize:"17px"}}
                  >
                  <PaymentOrderInfo invoice={invoice} 
                  handleChange={handleChange}
                  />
                  </TabPanel>
                  <TabPanel header="Bank Accounts"  headerStyle={{fontSize:"17px"}}>
                    <PaymentBankAccounts payment={invoice} handleChange={handleChange} refreshData={refreshData}/>
                  </TabPanel>
                  <TabPanel header="Purchase Invoice"  headerStyle={{fontSize:"17px"}}>
                    <PaymentPurchaseInvoice payment={invoice} />
                  </TabPanel>
                  <TabPanel header="History"  headerStyle={{fontSize:"17px"}}>
                    <PaymentOrderHistory payment={invoice} />
                  </TabPanel>
                  <TabPanel
                  header="Comments & Attachments" headerStyle={{fontSize:"17px"}}
                  >
                    <PaymentOrderComments
                      invoice={invoice}
                      handleChange={handleChange}
                      paymentOrderAttachments={paymentOrderAttachments}
                      setPaymentOrderAttachments={setPaymentOrderAttachments}
                    />
                  </TabPanel>
                </TabView>
                </div>
              {/* <div className="d-flex justify-content-end align-items-center">
                {staticButtons}
                {actionButtons}
              </div> */}
            </div>
            <div className="mx-4">
              <Pane className="">
                <PaymentOrderDocPreview
                  paymentAttachments={invoice?.paymentAttachments}
                  isDesktop={isDesktop}
                  paymentOrderId={paymentOrderId}
                />
              </Pane>
            </div>
          </SplitPane>
          </div>
          :
        (
          /* mobile */
        <div className="mt-4">
          <PaymentOrderInfo invoice={invoice} />
          <PaymentOrderHistory payment={invoice} />
          <PaymentOrderDocPreview
            paymentAttachments={invoice?.paymentAttachments}
            isDesktop={isDesktop}
            paymentOrderId={paymentOrderId}
          />
          <PaymentOrderComments
            invoice={invoice}
            handleChange={handleChange}
            paymentOrderAttach={paymentOrderAttachments}
            setPaymentOrderAttach={setPaymentOrderAttachments}
          />
          <div className="d-flex align-items-center ml-4">
            {staticButtons}
            {actionButtons}
          </div>
        </div>
        )}
      </div>
    ) : (
      <Page404 />
    )
  ) : (
    <Loader />
  );
};

export default EditPaymentOrder;
